"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _TagFilter = _interopRequireDefault(require("@rsuite/icon-font/lib/application/TagFilter"));

// Generated by script, don't edit it please.
var TagFilter = (0, _createSvgIcon["default"])({
  as: _TagFilter["default"],
  ariaLabel: 'tag filter',
  category: 'application',
  displayName: 'TagFilter'
});
var _default = TagFilter;
exports["default"] = _default;
module.exports = exports.default;